import type { IsoDateString } from '@skynet/formatting-date';
import type { GenericError, RequestStatus } from '@skynet/data-ws-core';

export interface LogsState {
  error: null | GenericError;
  requestStatus: null | RequestStatus;
  list: LogItem[];
}

export interface LogItem {
  ID?: number;
  key?: number;
  Date: IsoDateString;
  Message: string;
  Author: string;
  EntityType: 'Loan' | 'Retainer';
  EntityID: number;
  EntityName?: string;
}

export interface JsonLogSuccess {
  command: 'Log';
  list: LogItem[];
}

export enum LogsCommand {
  Log = 'Log',
}
